import { matchPath } from 'react-router-dom';

export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path.includes('http');
}

export function getActive(path, pathname, exact = false) {
  const exactMatch = exact || path === '/';
  return path ? !!matchPath({ path, end: exactMatch }, pathname) : false;
}
